const CACHE_NAME = `mercafacil-cache-${process.env.VUE_APP_CACHE_HASH}`
const CACHE_EXPIRATION = 48 * 60 * 60 * 1000

export async function setCache(key, data, lastUpdated, processingUUID) {
  const cache = await caches.open(CACHE_NAME)
  const expirationDate = Date.now() + CACHE_EXPIRATION
  const cacheData = {
    data,
    lastUpdated,
    processingUUID,
    expiration: expirationDate,
  }
  const response = new Response(JSON.stringify(cacheData))
  await cache.put(key, response)
}

export async function getCache(key) {
  const cache = await caches.open(CACHE_NAME)
  const cachedResponse = await cache.match(key)

  if (!cachedResponse) {
    return null
  }

  const cachedData = await cachedResponse.json()
  if (Date.now() > cachedData.expiration) {
    await cache.delete(key)
    return null
  }

  return cachedData
}

export async function clearAllCache() {
  const cacheNames = await caches.keys()
  for (const cacheName of cacheNames) {
    await caches.delete(cacheName)
  }
}
